<template>
  <div v-if="editEmailGroupMember" class="d-flex align-items-center">
    <GuInput v-model="emailGroupMemberEmail" size="sm" />
    <i v-if="updateRequestInProgress" class="bx bx-loader-alt bx-spin ms-2" />
    <GuButton 
      variant="primary"
      size="sm"
      class="ms-2"
      :disabled="updateRequestInProgress"
      @click="saveEditEmailGroupMember"
    >
      Save
    </GuButton>
    <GuButton 
      variant="secondary"
      size="sm"
      class="ms-2"
      :disabled="updateRequestInProgress"
      @click="editEmailGroupMember = false"
    >
      Cancel
    </GuButton>
  </div>
  <div v-else class="d-flex align-items-center">
    <span>{{ emailGroupMemberEmail }}</span>
    <i class="bx bx-edit ms-2" @click="editEmailGroupMember = true" />
  </div>
</template>

<script setup>
import { updateCompanyEmailGroupMember } from '@companies/api/companies.api'
import { ref, defineProps } from 'vue'
import { useToast } from '@shared/gu-components/toast'
import { GuButton } from '@shared/gu-components/button'
import { GuInput } from '@shared/gu-components/input'

const { toast } = useToast()

const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
  emailGroup: {
    type: Object,
    required: true,
  },
  emailGroupMember: {
    type: Object,
    required: true,
  },
})

const emailGroupMemberEmail = ref(props.emailGroupMember.email)
const editEmailGroupMember = ref(false)
const updateRequestInProgress = ref(false)

const emits = defineEmits(['emailGroupMemberUpdated'])

const { mutateAsync: updateCompanyEmailGroupMutation } = updateCompanyEmailGroupMember(props.company.id, props.emailGroup.id, props.emailGroupMember.id)
async function saveEditEmailGroupMember () {
  try {
    updateRequestInProgress.value = true
    const response = await updateCompanyEmailGroupMutation({ 
      email: emailGroupMemberEmail.value,
    })
    emits('emailGroupMemberUpdated', {
      id: response.id,
      email: response.email,
      updatedAt: response.updatedAt,
    })
    setTimeout (() => toast({
      variant: 'success',
      description: `Email updated successfully to "${response.email}"`,
    }), 0)
    emailGroupMemberEmail.value = false
  } catch (error) {
    console.error('Error updating email:', error)
    toast({
      variant: 'danger',
      description: error?.response?.data?._message || 'Error updating email, please try again',
      duration: Infinity,
    })
  }
  updateRequestInProgress.value = false
}
</script>
